import React from 'react'

export default props => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 17"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10V4H4v6H0l7 7 7-7h-4Zm4-10v2H0V0h14Z"
      fill="#000"
    />
  </svg>
)
